// Angular
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
// Partials for CRUD
import {
  ActionNotificationComponent,
  DeleteEntityDialogComponent,
  FetchEntityDialogComponent,
  UpdateStatusDialogComponent,
  ConfirmActionDialogComponent,
} from '../../../../views/partials/content/crud';
import { GeneralActionDialogComponent } from '../../../../views/partials/content/crud/general-action-dialog/general-action-dialog.component';

export enum MessageType {
  Create,
  Read,
  Update,
  Delete,
}

@Injectable()
export class LayoutUtilsService {
  /**
   * Service constructor
   *
   * @param snackBar: MatSnackBar
   * @param dialog: MatDialog
   */
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

  /**
   * Showing (Mat-Snackbar) Notification
   *
   * @param message: string
   * @param type: MessageType
   * @param duration: number
   * @param showCloseButton: boolean
   * @param showUndoButton: boolean
   * @param undoButtonDuration: number
   * @param verticalPosition: 'top' | 'bottom' = 'top'
   */
  showActionNotification(
    message: string,
    type: MessageType = MessageType.Create,
    duration = 10000,
    showCloseButton = true,
    showUndoButton = false,
    undoButtonDuration = 3000,
    verticalPosition: 'top' | 'bottom' = 'bottom',
  ) {
    const data = {
      message,
      snackBar: this.snackBar,
      showCloseButton,
      showUndoButton,
      undoButtonDuration,
      verticalPosition,
      type,
      action: 'Undo',
    };
    return this.snackBar.openFromComponent(ActionNotificationComponent, {
      duration,
      data,
      verticalPosition,
    });
  }

  /**
   * Showing Confirmation (Mat-Dialog) before Entity Removing
   *
   * @param title: string
   * @param description: string
   * @param waitDescription: string
   */
  deleteElement(title = '', description = '', waitDescription = '') {
    return this.dialog.open(DeleteEntityDialogComponent, {
      data: { title, description, waitDescription },
      width: '440px',
    });
  }

  /**
   * Showing Confirmation (Mat-Dialog) before Action
   *
   * @param title: string
   * @param description: string
   * @param waitDescription: string
   * @param hideConfirmBtn: boolean
   */
  confirmAction(title = '', description = '', waitDescription = '', hideConfirmBtn = false) {
    return this.dialog.open(ConfirmActionDialogComponent, {
      data: { title, description, waitDescription, hideConfirmBtn },
      width: '450px',
      disableClose: true,
      closeOnNavigation: true,
    });
  }

  /**
   * Showing Fetching Window(Mat-Dialog)
   *
   * @param data: any
   */
  fetchElements(data) {
    return this.dialog.open(FetchEntityDialogComponent, {
      data,
      width: '600px',
    });
  }

  /**
   * Showing Update Status for Entities Window
   *
   * @param title: string
   * @param statuses: string[]
   * @param messages: string[]
   */
  updateStatusForEntities(title, statuses, messages) {
    return this.dialog.open(UpdateStatusDialogComponent, {
      data: { title, statuses, messages },
      width: '600px',
    });
  }

  /**
   * Showing Confirmation (Mat-Dialog) before Action
   *
   * @param title: string
   * @param description: string
   * @param waitDescription: string
   * @param confirmText: string
   * @param cancelText: string
   * @param showConfirm: boolean
   * @param showCancel: boolean
   * @param width: string
   */
  generalDialog(
    title = '',
    description = '',
    waitDescription = '',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    showConfirm = true,
    showCancel = true,
    width = '450px',
  ) {
    return this.dialog.open(GeneralActionDialogComponent, {
      width,
      disableClose: true,
      closeOnNavigation: true,
      data: {
        title,
        description,
        waitDescription,
        confirmText,
        cancelText,
        showConfirm,
        showCancel,
      },
    });
  }
}
